import React from 'react';
import './Portfolio.css';
import {Swiper, SwiperSlide} from 'swiper/react';
import jitsicirlce from "../../img/jitsicircle.png";
import musicapp1 from "../../img/musicapp1.png";
import clothingstore from "../../img/clothingstore.png";
import 'swiper/css';
import {themeContext} from '../../Context';
import { useContext } from "react";

const Portfolio = () => {

    const theme = useContext (themeContext);
    const darkMode = theme.state.darkMode;
  return (
    <div className='portfolio' id = 'Portfolio'>
        <span style={{color: darkMode? 'white': ''}}>Recent Projects</span>
        <span>Portfolio</span>

        <Swiper
        spaceBetween={30}
        slidesPerView= {4}
        grabCursor= {true}
        className= 'portfolio-slider'
        >
            <SwiperSlide>
            <div className='jitsi'>
            <img src={jitsicirlce} alt="" />
            </div>
            </SwiperSlide>

            <SwiperSlide>
            <div className='cloth'>
            <img src={clothingstore} alt="" />
            </div>
            </SwiperSlide>

            <SwiperSlide>
                <div className='img-music'>
                <img src={musicapp1} alt="" />
                </div>
            </SwiperSlide>
        </Swiper>
    </div>

    
  )
}

export default Portfolio